export default function () {
  controller('file', self => {
    let input = self.find('input[type="file"]');

    input.on('change', e => {
      let fileName = e.target.files[0].name;
      let block = $(e.currentTarget).closest(self);
      let text = block.find('.file__text');

      text.text(fileName);
      block.addClass('selected');
    })
  });
}
